import QuizInit from '../../components/quizzes/quiz-init.vue';
import QuizNew from '../../components/quizzes/quiz-new.vue';
import QuizResult from '../../components/quizzes/quiz-result.vue';

export default {
    path: '/quiz',
    component: {
        render (c) {
            return c('router-view')
        }
    },
    children: [
        {
            path: '',
            component: QuizInit,
            meta: {
                requiresAuth: true,
                hideHeaderButtons: true,
                headerStyle: 'inverted',
                hideFooter: true,
            },
        },
        {
            path: 'new',
            component: QuizNew,
            meta: {
                requiresAuth: true,
                hideHeaderButtons: true,
                headerStyle: 'hidden',
                hideFooter: true,
            },
        },
        {
            path: 'result',
            component: QuizResult,
            meta: {
                requiresAuth: true,
                hideHeaderButtons: true,
                headerStyle: 'inverted',
                hideFooter: true,
            },
        },
    ]
};